export default __webpack_public_path__ + "static/media/twitter.665d9096.svg";